import React, { Component } from 'react';
import { get } from 'lodash';
import { Row, Col, Label } from 'react-bootstrap';
import InputTip from 'components/atoms/form/InputTip';
import BrandSubheaderFieldName from 'components/atoms/form/BrandSubheaderFieldName';
import ChannelVisibilitySubHeading from 'components/molecules/ChannelVisibilitySubHeading';


class ViewChannelConfiguration extends Component {
    render() {
        const { channels, channelConfig, brandName, overrideBrandEnabledChannels } = this.props;

        let brandOverrideCopy;
        const showBrandOverrideCopy = brandName;
        if (showBrandOverrideCopy) {
            if (overrideBrandEnabledChannels) {
                brandOverrideCopy = `Entity overrides ${brandName} Brand channel setting.`;
            } else {
                brandOverrideCopy = `Inherited channel settings from ${brandName} Brand.`;
            }
        }

        return (
            <React.Fragment>
                <ChannelVisibilitySubHeading />

                {showBrandOverrideCopy && <InputTip>{brandOverrideCopy}</InputTip>}

                <Row>
                    <Col xs={4}><BrandSubheaderFieldName>Channel</BrandSubheaderFieldName></Col>
                    <Col xs={8}><BrandSubheaderFieldName>Visibility</BrandSubheaderFieldName></Col>
                </Row>

                {channels.map((channel, index) => (
                    <Row key={index}>
                        <Col xs={4}>{channel.displayName}</Col>
                        <Col xs={8}>
                            <Label bsStyle={get(channelConfig[channel.key], 'enabled', true) ? 'info' : 'default'}>
                                {get(channelConfig[channel.key], 'enabled', true) ? 'Shown' : 'Hidden'}
                            </Label>
                        </Col>
                    </Row>
                ))}
            </React.Fragment>
        );
    }
}

export default ViewChannelConfiguration;



// WEBPACK FOOTER //
// ./src/components/molecules/ViewChannelConfiguration.js